import React, { useEffect, useState, useCallback } from 'react'
import PageHeader from '../../common/pageHeader'
import HeaderSection from '../../common/headerSection'
import { Modal, Button } from 'react-bootstrap'
import CustomTable from '../../../widgets/table'
import { EsignModal } from '../../../widgets/alertModal'
// Import your report components here

import { columns as baseColumns } from './partials/column'
import { TfiClose } from 'react-icons/tfi'
import { useTranslation } from 'react-i18next';
import AlertModal from '../../../widgets/alertModal'
import CustomToast from '../../../widgets/toaster'
import Pagination from '../../../widgets/pagination';
import { userService } from '../../../service/userService'
import { deviceRegistration } from '../../../service/deviceRegistration'
// import NotificationConfigModal from './partials/modal'
import { DEFAULT_PAGE_SIZE } from '../../../constants/constants'
import baseUrl from '../../../service'
import ProductionBatchSummaryReport from '../reportpdf/summaryReport/productionbatchSummaryReport'
import ActiveAirSamplingReport from '../reportpdf/summaryReport/activeSamplingReport'
import SurfaceMonitoringReport from '../reportpdf/summaryReport/surfaceMonitoringReport_v2'
import SurfaceMonitoring from '../reportpdf/summaryReport/surfaceMonitoring'
import PersonnelMonitoring from '../reportpdf/summaryReport/personnelMonitoring'
import BatchSummaryReport from '../reportpdf/summaryReport/batchSummaryReport'
import PassiveAIrSampingReport from '../reportpdf/summaryReport/passiveSamplingReport'
import GlovePortReport from '../reportpdf/summaryReport/glovePortReport'
import moment from 'moment'
import { scheduleService } from '../../../service/scheduleService'
import AnaerobicMonitoringReport from '../reportpdf/summaryReport/anaerobicMonitoring'
import CompressedAirMonitoringReport from '../reportpdf/summaryReport/compressedAirmonitoring'
import NitrogenMonitoringReport from '../reportpdf/summaryReport/nitrogenMonitoring'
import PlateSamplingReport from '../reportpdf/summaryReport/plateSamplingReport'


interface DeviceRegisterItem {
  slno: string; 
  downloadPath: string;
  document_name?: string; 
  id?: string;
  status?: string;
  file_name?: string;
  generated_date_time?: string;
  file_status?: string;
  filters?: string;
  view_api_path?: string;
  publish_api_path?: string;
}

const DownloadReports = () => {

  

    const date7DaysAgo = new Date();
    date7DaysAgo.setDate(date7DaysAgo.getDate() - 7);
    const formattedDate7DaysAgo = date7DaysAgo.toISOString().split("T")[0];

    
    const dateTime = `${formattedDate7DaysAgo} 00:00:00`;


  const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split('T')[0]; // YYYY-MM-DD

  const endDate = new Date(currentDate);
    const formattedEndDate = endDate.toISOString().split('T')[0]; // YYYY-MM-DD
    const formattedEndTime = currentDate.toTimeString().split(' ')[0]; // HH:MM:SS
    const endDateTime = `${formattedEndDate} 23:59:59`;


  const { t } = useTranslation();
  const [deviceRegister, setDeviceRegister] = useState<DeviceRegisterItem[]>([]);
  const [useEffectRequired, setuseEffectRequired] = useState(false)
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("");
   // table pagination for sample type
   const [page, setPage] = useState(1);
   const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
   const [totalPages, setTotalPages] = useState(0);
   const [totalElements, setTotalElements] = useState(0);
   // table pagination for sample Sub type
  const [keyWord, setkeyWord] = useState("")
  const [permission, setPermission] = useState<any>([]);
  const [reportName , setReportName] = useState([]);
  const [sort, setSort] = useState("id");
  const [order, setOrder] = useState("desc");
  const sortRemoveList=["generated_date_time","status","file_status","action"]
  const [fileStatus, setfileStatus] = useState("");
  const [loadingItems, setLoadingItems] = useState<Record<string, boolean>>({});
  const [pollingIntervals, setPollingIntervals] = useState<Record<string, NodeJS.Timeout>>({});
  const [isAnyPublishing, setIsAnyPublishing] = useState(false);
  const [showEsignAlert, setShowEsignAlert] = useState(false);
  const [showApproveConfirm, setShowApproveConfirm] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [fromDate, setFromDate] = useState(dateTime);
  const [toDate, setToDate] = useState(endDateTime);
  const [usersList, setUsersList] = useState<Array<any>>([]);
  const [generatedby, setGeneratedby] = useState("");

  useEffect(() => {

    var storedData = localStorage.getItem('userDetails');

    if(storedData) {
      var storedObject = JSON.parse(storedData);
      getPermissionByRole(storedObject[0].role_master_id);
    }
    listReportType();
    listDeviceList();
    getMasterUserList();
    setuseEffectRequired(false)
  }, [useEffectRequired])
  

  //get permission by role 
  const getPermissionByRole = async (role : number) => {
    try {
      const response = await userService.getPermissionByRole(role);
      if(response.status && response.statusCode === 200){
        setPermission(response.data.permissions)
      }
    } catch (error) {
      console.error(error);
    }
  }

  // getMasterUserList()
    const getMasterUserList = async () => {
      try {
        // const response = await scheduleService.getMasterUserList();
        const response = await scheduleService.getMasterUserListWithUserCode();
        if (response.status && response.statusCode === 200) {
          try {
            if (Array.isArray(response.data) && response.data?.length > 0) {
              let rowData: any = response.data.map(
                (element: any, index: number) => {
                  return {
                    slno: index + 1,
                    id: element.id,
                    name: element.user_fullname_with_id
                    // name: (
                    //   (element?.first_name).trim() +
                    //   " " +
                    //   (element?.last_name).trim()
                    // ).trim(),
                  };
                }
              );
              setUsersList(rowData);
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          setUsersList([]);
        }
      } catch (error) {
        console.error("user response", error);
      }
    };

  //get all_raw_material_type list from api  
  const listDeviceList = async () => {
    try {
      const response = await deviceRegistration.listdownloadReport(page, pageSize,sort, order, keyWord,fileStatus,generatedby,fromDate,
                toDate,);
      if(response.status && response.statusCode === 200){
        try {
            // if ( Array.isArray(response.data) && response.data?.length > 0) {
            //   setTotalPages(response?.totalPages)
            //   setTotalElements(response?.totalElements)
            
            // Always sync totals from API, even when there are no rows
            setTotalPages(response?.totalPages || 0)
            setTotalElements(response?.totalElements || 0)

            if (Array.isArray(response.data) && response.data?.length > 0) {
              let rowData: any = response.data.map((element: any, index: number) => {

                return { 
                    slno: index + 1, 
                    document_name: element.document_name,
                    id : element.id,
                    status : element.download_status,
                    file_name: element.file_name,
                    generated_date_time: element.generated_date_time,
                    downloadPath:element.downloadPath,
                    is_executed: element.is_executed,
                    file_status: element.file_status ? element.file_status.charAt(0).toUpperCase() + element.file_status.slice(1) : '',
                    filters:element.filters,
                    view_api_path:element.view_api_path,
                    publish_api_path:element.publish_api_path,
                    download_status:element.download_status,
                    generated_user_name:element.generated_user_name,
                    is_publish_requested:element.is_publish_requested,
                    downloads_type_id:element.downloads_type_id
                };
              });
              setDeviceRegister(rowData);
            } else {
              // Clear list when no rows
              setDeviceRegister([]);
            }
          } catch (error) {
            console.log(error);
            setDeviceRegister([]);
            setTotalPages(0);
            setTotalElements(0);
          }
      }else {
        setDeviceRegister([]);
        setTotalPages(0);
        setTotalElements(0);
      }
    } catch (error) {
      console.error('user response', error);
      setDeviceRegister([]);
      setTotalPages(0);
      setTotalElements(0);
    }
  }


  //handle table pagination 
  const handlePageChange = (newPage : any, pageSize?: number) => {
    setPage(newPage)
    if(pageSize) {
      setPageSize(pageSize)
    }
    setuseEffectRequired(true)
  };

  //handle filter section in sample type
  const handleFilter = (key: string, value: any) => {
    if(key === "Role") {
      // setRole(value)
    } else if (key === "ReportType") {
      setkeyWord(value)
    }else if (key === "fileStatus") {
    setfileStatus(value);
  }else if (key === "generatedby") {
      setGeneratedby(value)
    }else if (key === "FromDate") {
              const formattedDate = value ? moment(value).format("YYYY-MM-DD 00:00:00") : "";
              setFromDate(formattedDate)
              setToDate("")
          } else if (key === "ToDate") {
              const formattedDate = value ? moment(value).format("YYYY-MM-DD 23:59:59") : "";
              setToDate(formattedDate)
          }
    // Reset to first page whenever filters change
    setPage(1)
    setuseEffectRequired(true)
  }

  const listReportType = async () => {
    try {
      const response = await deviceRegistration.listReportType();
      if(response.status && response.statusCode === 200){
        try {
            if ( Array.isArray(response.data) && response.data?.length > 0) {
              let rowData: any = response.data.map((element: any, index: number) => {

                return { 
                    id: element.id,
                    label: element.type_name,
                };
              });
              setReportName(rowData);
            }
          } catch (error) {
            console.log(error); 
          }
      }
    } catch (error) {
      console.error('Plate response', error);
    }
}


const handleDownload = (slno: string) => {
  const matchedItem = deviceRegister.find((item) => item.slno === slno); // Find an individual item
  if (matchedItem) {
    const link = baseUrl + matchedItem.downloadPath; // Access downloadPath on the matched item
    window.open(link, '_blank');
  }
};

const handlePublish = async (item: any, e?: React.MouseEvent) => {
  e?.stopPropagation();
  e?.preventDefault();
  
  // Prevent multiple clicks
  if (isAnyPublishing || (item.id && loadingItems[item.id])) return;
  
  try {
    // Set loading states
    setIsAnyPublishing(true);
    setLoadingItems(prev => ({ ...prev, [item.id]: true }));
    
    const response = await deviceRegistration.publishButton(item.id);
    
    if (response && response.statusCode === 200) {
      setToastType("success");
      setToastMessage("Document Published In Progress");
      setShowToast(true);
      
      // Start polling for status
      startPollingForStatus(item.id);
    } else {
      setToastType("error");
      setToastMessage(response?.message || "Failed to initiate publishing");
      setShowToast(true);
      resetPublishingState(item.id);
    }
  } catch (error) {
    setToastType("error");
    setToastMessage("Error initiating publishing");
    setShowToast(true);
    resetPublishingState(item.id);
    console.error(error);
  }
};

// Helper function to reset publishing state
const resetPublishingState = (itemId: string) => {
  setIsAnyPublishing(false);
  setLoadingItems(prev => ({
    ...prev,
    [itemId]: false
  }));
};

const startPollingForStatus = (itemId: string) => {
  // Clear any existing interval for this item
  if (pollingIntervals[itemId]) {
    clearInterval(pollingIntervals[itemId]);
  }

  //console.log('Starting polling for item:', itemId);
  
  const interval = setInterval(async () => {
    try {
      //console.log('Checking publish status for item:', itemId);
      const statusResponse = await deviceRegistration.checkPublishedOrNot(itemId);
      //console.log('Publish status response:', statusResponse);
      
      if (statusResponse && statusResponse.statusCode === 200) {
        // Check for is_published in the response
        const isPublished = statusResponse.is_published || 
                          statusResponse.data?.is_published || 
                          (statusResponse.data?.data && statusResponse.data.data.is_published);
        
        //console.log('Is published status:', isPublished);
        
        if (isPublished) {
          // Stop polling immediately when published
          clearInterval(interval);
          setPollingIntervals(prev => {
            const newIntervals = { ...prev };
            delete newIntervals[itemId];
            return newIntervals;
          });
          // Reset loading states
          setIsAnyPublishing(false);
          setLoadingItems(prev => ({ ...prev, [itemId]: false }));
          
          // Show success message
          setToastType("success");
          setToastMessage("Document Published Successfully");
          setShowToast(true);
          
          // Refresh the list to update the UI with download button
          await listDeviceList();
          
          // After refreshing the list, find the published item and trigger download
          const updatedList = deviceRegister;
          const publishedItem = updatedList.find(item => item.id === itemId);
          
          if (publishedItem) {
            // Small delay to ensure the UI has updated
            setTimeout(() => {
              // Find the download button in the DOM and click it
              const downloadButton = document.querySelector(`button[data-item-id="${itemId}"][data-action="download"]`);
              if (downloadButton) {
                (downloadButton as HTMLButtonElement).click();
              } else {
                console.log('Download button not found, manual download required');
              }
            }, 500);
          }
        }
        // If not published yet, continue polling
      } else {
        // Handle error or invalid response
        console.error("Error in publish status response:", statusResponse);
      }
    } catch (error) {
      console.error("Error checking publish status:", error);
    } finally {
      // Always reset loading states when polling is complete or failed
      setIsAnyPublishing(false);
      setLoadingItems(prev => ({
        ...prev,
        [itemId]: false
      }));
    }
  }, 5000); // Poll every 5 seconds

  // Store the interval ID
  setPollingIntervals(prev => ({
    ...prev,
    [itemId]: interval as unknown as NodeJS.Timeout
  }));
};

// Clean up intervals on component unmount
React.useEffect(() => {
  return () => {
    Object.values(pollingIntervals).forEach(interval => {
      clearInterval(interval);
    });
  };
}, [pollingIntervals]);

const handleSort = (key: string, value: boolean) => {
  setSort(key);
  if (value) {
  setOrder("asc");
  } else {
  setOrder("desc");
  }
  setuseEffectRequired(true);
};
  // Permission checker for action buttons
  const hasPermission = (perm: string): boolean => {
    if (!permission) return false;
    try {
      if (Array.isArray(permission)) {
        return permission.some((p: any) => {
          if (typeof p === 'string') return p === perm;
          return (
            p?.permission_name === perm ||
            p?.code === perm ||
            p?.permissionCode === perm ||
            p?.name === perm
          );
        });
      }
    } catch {}
    return false;
  };

  // Handle button actions
  const handleAction = async (item: DeviceRegisterItem, action: 'approved' | 'published' | 'download', e?: React.MouseEvent) => {
    e?.stopPropagation();
    e?.preventDefault();
    switch (action) {
      case 'download':
        handleDownload(item.slno);
        break;
      case 'published':
        await handlePublish(item);
        break;
      case 'approved':
        setToastType('info');
        setToastMessage(`${action} clicked for ${item.file_name || item.document_name || item.slno}`);
        setShowToast(true);
        break;
      default:
        break;
    }
  };


  const handleESignConfirm = useCallback(async (remark: string) => {
    if (!selectedItem) return;
    
    try {
      setLoadingItems(prev => ({ ...prev, [selectedItem.id]: true }));
      
      const dataToSend = {
        id: selectedItem.id,
        remarks: remark 
      };

      const response = await deviceRegistration.ApproveButton(dataToSend);
      
      if (response.status && response.statusCode === 200) {
        setToastType("success");
        setToastMessage("Document Approved Successfully");
        listDeviceList();  // Refresh the list
      } else {
        setToastType("error");
        setToastMessage(response.message || "Failed to approve document");
      }
      setShowToast(true);
    } catch (error) {
      setToastType("error");
      setToastMessage("Error approving document");
      setShowToast(true);
      console.error(error);
    } finally {
      setLoadingItems(prev => ({ ...prev, [selectedItem.id]: false }));
      setSelectedItem(null);
    }
  }, [selectedItem]);

  const handleQaApprove = (item: any, e?: React.MouseEvent) => {
    e?.stopPropagation();
    e?.preventDefault();
    
    setSelectedItem(item);
    setShowApproveConfirm(true);
  };

  const handleApproveConfirm = () => {
    setShowApproveConfirm(false);
    setShowEsignAlert(true);
  };

  // Add action buttons to data
  const tableData = (deviceRegister || []).map((item: DeviceRegisterItem & { id?: string }) => {
    // Use file_status if available, otherwise fall back to status
    const status = (item.file_status || item.status || '').toLowerCase();
    //console.log('Row data:', { id: item.id, status, file_status: item.file_status }); // Debug log
    let actionButton = null;

    if (status.includes('pending')) {
      const hasQaReview = hasPermission('qa_review');
      actionButton = (
        <button 
          className={`tableProcessBtn1  ${!hasQaReview ? 'tableProcessBtn1disabled' : ''}`}
          onClick={(e) => hasQaReview && handleQaApprove(item, e)}
          title={!hasQaReview ? 'You do not have permission to approve documents' : ''}
          disabled={!hasQaReview || !item.id || loadingItems[item.id]}
        >
          {item.id && loadingItems[item.id] ? 'Processing...' : 'QA Approve'}
        </button>
      );
    } else if (status.includes('approved')) {
      const hasDownloadReport = hasPermission('download_report');
      actionButton = (
        <button 
          className={`tableProcessBtn2  ${!hasDownloadReport ? 'tableProcessBtn2disabled' : ''}`}
          onClick={(e) => hasDownloadReport && handlePublish(item, e)}
          title={!hasDownloadReport ? 'You do not have permission to publish documents' : ''}
          disabled={!hasDownloadReport || isAnyPublishing || !!(item.id && loadingItems[item.id])}
        >
          {item.id && loadingItems[item.id] ? 'Publishing...' : 'Publish/Print'}
        </button>
      );
    } else if (status.includes('published')) {
      const hasDownloadReport = hasPermission('download_report');
      actionButton = (
        <button 
          className={`tableProcessBtn3  ${!hasDownloadReport ? 'tableProcessBtn3disabled' : ''}`}
          onClick={(e) => hasDownloadReport && handleAction(item, 'download', e)}
          title={!hasDownloadReport ? 'You do not have permission to download reports' : ''}
          data-item-id={item.id}
          data-action="download"
        >
          Download Report
        </button>
      );
    }

    return {
      ...item,
      action: <div className="">{actionButton}</div>
    };
  });

  // Clone columns and add Action column
  const columns = [
    ...baseColumns,
    {
      Header: "Action",
      accessor: "action",
    },
    // {
    //     Header: "Download Status",
    //     accessor: "download_status",
    // },
  ];
  const [showView, setShowView] = useState(false);
  const [selectedReport, setSelectedReport] = useState<any>(null);
  const [activeComponent, setActiveComponent] = useState<React.ReactNode>(null);
  
  // In handleViewClick
const handleViewClick = (id: string, viewValue: boolean) => {
  const reportData = deviceRegister.find((row) => row.slno === id);
  if (reportData) {
    // Parse filters from the report data
    const filters = reportData.filters ? JSON.parse(reportData.filters) : {};
    const viewApiPath = reportData.view_api_path || '';
    
    // Map the filter keys to match the component's expected format
    const mappedFilters = {
      location: filters.area_master_id || '',
      batchCode: filters.batch_number || '',
      lotCode: filters.lot_id || '',
      plateSerialNumber: filters.serial_number || '',
      fromDate: filters.from_date || '',
      toDate: filters.to_date || '',
      area: filters.area_id || "",
      productionSchedule: filters.schedule_production_id || "",
      productName: filters.product_id || "",
      activityType:filters.master_activities_id || "",

      // Add any additional mappings if needed
      ...filters // Spread the rest of the filters
    };

    //console.log('Mapped Filters:', mappedFilters);
    
// In handleViewClick
const documentName = reportData.document_name?.toLowerCase() || '';

if (documentName === 'summary report - active air sampling') {
  setSelectedReport(reportData);
  setActiveComponent(
    <ActiveAirSamplingReport 
      ishide={false} 
      filter={mappedFilters} 
      key={Date.now()}
    />
  );
} else if (documentName ==='summary report - passive air sampling') {
  setSelectedReport(reportData);
  setActiveComponent(
    <PassiveAIrSampingReport 
      ishide={false} 
      filter={mappedFilters} 
      key={Date.now()}
    />
  );

} else if (documentName ==='batch summary report') {
  setSelectedReport(reportData);
  setActiveComponent(
    <BatchSummaryReport 
      ishide={false} 
      filter={mappedFilters} 
      key={Date.now()}
    />
  );
} else if (documentName ==='production batch summary'||documentName ==='production batch summary report') {
  setSelectedReport(reportData);
  setActiveComponent(
    <ProductionBatchSummaryReport 
      ishide={true} 
      filter={mappedFilters} 
      key={Date.now()}
    />
  );
} else if (documentName ==='summary report - personnel monitoring') {
  setSelectedReport(reportData);
  setActiveComponent(
    <PersonnelMonitoring 
      ishide={false} 
      filter={mappedFilters} 
      key={Date.now()}
    />
  );
} else if (documentName ==='summary report - surface monitoring through swab' ||documentName === 'summary report - surface swab monitoring'||documentName === 'summary report - surface monitoring through swab collection'||documentName === 'summary report - surface monitoring swab collection') {
  setSelectedReport(reportData);
  setActiveComponent(
    <SurfaceMonitoring 
      ishide={false} 
      filter={mappedFilters} 
      key={Date.now()}
    />
  );
} else if (documentName ==='summary report - contact plate monitoring') {
  setSelectedReport(reportData);
  setActiveComponent(
    <SurfaceMonitoringReport 
      ishide={false} 
      filter={mappedFilters} 
      key={Date.now()}
    />
  );
} else if (documentName ==='summary report - plate sampling') {
  setSelectedReport(reportData);
  setActiveComponent(
    <PlateSamplingReport 
      ishide={false} 
      filter={mappedFilters} 
      key={Date.now()}
    />
  );
} else if (documentName ==='summary report - anaerobic monitoring') {
  setSelectedReport(reportData);
  setActiveComponent(
    <AnaerobicMonitoringReport 
      ishide={false} 
      filter={mappedFilters} 
      key={Date.now()}
    />
  );
} else if (documentName ==='summary report - nitrogen monitoring') {
  setSelectedReport(reportData);
  setActiveComponent(
    <NitrogenMonitoringReport 
      ishide={false} 
      filter={mappedFilters} 
      key={Date.now()}
    />
  );
} else if (documentName ==='summary report - compressed air monitoring') {
  setSelectedReport(reportData);
  setActiveComponent(
    <CompressedAirMonitoringReport 
      ishide={false} 
      filter={mappedFilters} 
      key={Date.now()}
    />
  );
} else if (documentName ==='summary report - glove port monitoring'||documentName ==='summary report - glove monitoring') {
  setSelectedReport(reportData);
  setActiveComponent(
    <GlovePortReport 
      ishide={false} 
      filter={mappedFilters} 
      key={Date.now()}
    />
  );
}
setShowView(viewValue);
    }
  
};
  return (
    <div>
      <HeaderSection />
      <PageHeader pageHeader={t('downloadPdfScreen.download')} />
      <CustomToast
        show={showToast}
        onClose={() => setShowToast(false)}
        delay={5000}
        message={toastMessage}
        toastType={toastType}
      />
      <div className='me-3' style={{marginTop: "20px"}}>
        <div className='mx-3 pe-2' style={{"height":"45vh"}}>
          <CustomTable 
            tableHead={t('downloadPdfScreen.download')}
            data={tableData}
            columns={columns}
            isEditable={false}
            isTempDeletable={false}
            totalElements={totalElements}
            isActionVisible={false}  
            isViewVisible={true}
            onViewClick={handleViewClick}
            isSeachable={false}
            isToggleStatus={false}
            isResetPassword={false}
            addButton={false}
            onUseEffectRequired={() => setuseEffectRequired(true)}
            onFilterClick={handleFilter}
            changeRoleButton={false}
            showTableBtn={false}     
            reportName={reportName}
            onSortClick={handleSort}
            removeSortList={sortRemoveList}
            fileStatus={fileStatus}
            showToDateFilter={true}
            showFromDateFilter={true}
            generatedby={usersList}
          />
        </div>
            <div>
              <Pagination
                page={page}
                totalPages={totalPages}
                handlePageChange={handlePageChange}
              />
            </div>
        </div>

         <Modal
  className="top-right-modal-lg"
  centered={false}
  size="lg"
  show={showView}
>
  <div className="modalHead">
    <p className="modalHeadText ms-3 pt-3 p-2">
      {selectedReport?.document_name || 'Report View'}
    </p>
    <div
      style={{ cursor: "pointer" }}
      onClick={() => setShowView(false)}
      className="p-2 mx-3 my-2 "
    >
      <TfiClose fill="#FFFFFF" />
    </div>
  </div>
  <div className="mt-2" style={{"overflow":"auto", "height": "80vh"}}>
    {activeComponent}
  </div>
  <div className="bottomArea">
    <button
      onClick={() => setShowView(false)}
      className="modalCancelBtn"
    >
      {t("buttons.cancel")}
    </button>
  </div>
</Modal>
<AlertModal
  show={showApproveConfirm}
  onHide={() => setShowApproveConfirm(false)}
  title={t("common.alert")}
  message={`approve this document?\n\nDocument: ${selectedItem?.document_name || 'N/A'}`}
  onConfirm={handleApproveConfirm}
/>
<EsignModal 
  show={showEsignAlert}
  onHide={() => {
    setShowEsignAlert(false);
    setSelectedItem(null);
  }}
  onConfirm={handleESignConfirm}
  needRemraks={true}
  screenName={"Download Reports"}
/>
    </div>

  )
}

export default DownloadReports;
